// extracted by mini-css-extract-plugin
export var buttons = "bk_ct";
export var container = "bk_k";
export var content = "bk_bY";
export var icon = "bk_bz";
export var iconContainer = "bk_bP";
export var image = "bk_d";
export var section = "bk_b";
export var selected = "bk_bg";
export var tab = "bk_fh";
export var tabText = "bk_fg";